import { ComponentsOverrides, Theme } from "@mui/material";
import { InternalThemeConfig } from "../../config";

const card = ({ spacing }: InternalThemeConfig): ComponentsOverrides<Theme>["MuiCard"] => ({
	root: {
		padding: spacing(2),
	},
});

export default card;
